/** Time-aware greeting: morning (05–11), afternoon (12–16), evening (17–04). */
export function greetingFor(date: Date = new Date()): string {
  const h = date.getHours()
  if (h >= 5 && h < 12) return 'Good morning'
  if (h >= 12 && h < 17) return 'Good afternoon'
  return 'Good evening'
}

/** First name from a display name or email ("Ada Lovelace" → "Ada", "ada.l@x.io" → "Ada"). */
export function firstName(nameOrEmail?: string | null): string {
  const s = (nameOrEmail || '').trim()
  if (!s) return ''
  const base = s.includes('@') ? s.split('@')[0].split(/[._-]/)[0] : s.split(/\s+/)[0]
  return base ? base.charAt(0).toUpperCase() + base.slice(1) : ''
}

export function greetingLine(name?: string | null, date?: Date): string {
  const n = firstName(name)
  return n ? `${greetingFor(date)}, ${n}!` : `${greetingFor(date)}!`
}
